import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
} from "../../components";

import "./styles.css";

const TestScores = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const [tests, setTests] = useState([
    {
      name: null,
      math: "",
      english: "",
      score: "",
      testDate: "",
      collegeBoard: "",
    },
  ]);

  useEffect(() => {
    if (questionnaire?.tests?.length > 0) {
      setTests(questionnaire.tests.map((test) => ({ ...test })));
    } else {
      setTests([
        {
          name: null,
          math: "",
          english: "",
          score: "",
          testDate: "",
          collegeBoard: "",
        },
      ]);
    }
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      {tests?.map((test, index) => (
        <div key={index} className={`${index > 0 ? "mt-6" : ""} `}>
          <div className="flex justify-between">
            <div className="section-header">Test {index + 1}</div>
          </div>
          <div className="grid grid-cols-2 gap-x-7 gap-y-6">
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Test Name"
                required
              />
              <Spacer height="0.3125em" />
              <questionnaireComponents.QuestionnaireValueBox
                value={test?.name}
              />
            </div>

            {(test?.name === "SAT" || test?.name === "ACT") && (
              <>
                <div>
                  <questionnaireComponents.QuestionnaireLabel
                    text="Math"
                    required
                  />
                  <Spacer height="0.3125em" />
                  <questionnaireComponents.QuestionnaireValueBox
                    value={test?.math}
                  />
                </div>
                <div>
                  <questionnaireComponents.QuestionnaireLabel
                    text="English"
                    required
                  />
                  <Spacer height="0.3125em" />
                  <questionnaireComponents.QuestionnaireValueBox
                    value={test?.english}
                  />
                </div>
                {test?.name === "SAT" && (
                  <div>
                    <questionnaireComponents.QuestionnaireLabel text="College Board" />
                    <Spacer height="0.3125em" />
                    <questionnaireComponents.QuestionnaireValueBox
                      value={test?.collegeBoard}
                    />
                  </div>
                )}
              </>
            )}

            {(test?.name === "IELTS" || test?.name === "TOEFL") && (
              <div>
                <questionnaireComponents.QuestionnaireLabel
                  text="Score"
                  required
                />
                <Spacer height="0.3125em" />
                <questionnaireComponents.QuestionnaireValueBox
                  value={test?.score}
                />
              </div>
            )}

            <div>
              <questionnaireComponents.QuestionnaireLabel text="Test Date" />
              <Spacer height="0.3125em" />
              <questionnaireComponents.QuestionnaireValueBox
                value={
                  test?.testDate
                    ? moment(test?.testDate).format("YYYY-MM-DD")
                    : null
                }
              />
            </div>
          </div>
        </div>
      ))}

      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Emergency Contact")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default TestScores;
